import { PanelHeaderData } from '../../../atomic-components/molecules/panels';

import * as ng from 'angular';

export class TemplateWebspaceWizardController {
    public static $inject: string[] = ['$translate'];

    public pageHeaderData: PanelHeaderData;

    constructor(
        private $translate: ng.translate.ITranslateService
    ) {}

    public $onInit(): void {
        this.pageHeaderData = {
            backwardLink: 'webhosting.dashboard',
            backwardText: this.$translate.instant('TR_140119-285630_TR'),
            panelHeaderRoute: '',
            panelHeaderRouteParams: {},
            panelIcon: 'box-alt',
            panelTitle: this.$translate.instant('TR_140119-4563cf_TR')
        };
    }
}

export class TemplateWebspaceWizardComponent implements ng.IComponentOptions {
    public bindings = {};
    public template = require('./webspace-wizard-template.html') as string;
    public controller = TemplateWebspaceWizardController;
}
